import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["disabled", "tabindex", "aria-hidden", "aria-label", "data-testid", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "v1-keypad__icon",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "v1-keypad",
    role: "group",
    "aria-label": _ctx.ariaLabel
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (key) => {
      return (_openBlock(), _createElementBlock("button", {
        key: key.value,
        type: "button",
        class: _normalizeClass(["v1-keypad__key", {
        'v1-keypad__key--action': key.action,
        'v1-keypad__key--spacer': key.spacer,
      }]),
        disabled: key.spacer,
        tabindex: key.spacer ? -1 : 0,
        "aria-hidden": key.spacer || undefined,
        "aria-label": key.value === 'backspace' ? _ctx.backspaceLabel : undefined,
        "data-testid": `v1-keypad-${key.value}`,
        onClick: ($event: any) => (_ctx.onPress(key))
      }, [
        (key.value === 'backspace')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "⌫"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(key.label), 1)
            ], 64))
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}